import React, { FC } from "react";
import { ListItem, ListItemProps } from "@mui/material"

const ListItemWrapper: FC<ListItemProps> = ({...props}) => <ListItem {...props}/>

export default ListItemWrapper;